import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
export default (function (_ref) {
  var app = _ref.app,
      store = _ref.store;
  var currentApp = app;
  currentApp.i18n = new VueI18n({
    locale: store.state.i18n.currentLocale.language,
    fallbackLocale: 'fr',
    silentTranslationWarn: process.env.NODE_ENV === 'production'
  });
});